import React from 'react';
interface TimelineBlockProps {
  number: number;
  title: string;
  description?: string;
}
export function TimelineBlock({
  number,
  title,
  description
}: TimelineBlockProps) {
  return <div className="flex items-start mb-8 last:mb-0" data-id="element-130">
      <div className="flex-shrink-0 mr-5" data-id="element-131">
        <div className="w-10 h-10 rounded-full bg-[#2563EB] flex items-center justify-center text-white font-bold text-base shadow-sm" data-id="element-132">
          {number}
        </div>
      </div>
      <div className="pt-1" data-id="element-133">
        <h4 className="font-bold text-gray-900 text-lg leading-tight mb-2" data-id="element-134">
          {title}
        </h4>
        {description && <p className="text-gray-600 text-base leading-relaxed" data-id="element-135">
            {description}
          </p>}
      </div>
    </div>;
}